import { InformationIcon } from "@/assets/icons";

interface InfoBoxProps {
  message: string;
}

const InfoBox = ({ message }: InfoBoxProps) => {
  return (
    <div className="bg-[#eeeeee] flex items-center justify-center gap-1 p-1 border rounded-lg border-gainsboro text-[12px]">
      <div aria-label="Information Icon">
        <InformationIcon className="fill-dim-gray" />
      </div>
      <span>{message}</span>
    </div>
  );
};

export default InfoBox;
